import { FC } from 'react'
import styled from 'styled-components'
import {
  LandingPageSection,
  LandingPageSectionPosition
} from '@/network/graphql.g'
import Link from '@/components/atoms/link'
import { validFor } from '@/theme/validFor'
import { BigAccentButton } from '@/components/atoms/button'
import { Flex, Grid } from '@/components/atoms/Grid'

type SummerSubCategoriesProps = {
  blackFridayCategory: LandingPageSection
  position: string
}

const SummerSubCategories: FC<SummerSubCategoriesProps> = ({
  blackFridayCategory,
  position
}) => {
  const blackFridaySortCategories = [...blackFridayCategory.categories].sort(
    (a, b) => a.sort - b.sort
  )

  return (
    <StyledGrid
      gridTemplateColumns={{
        mobile: '1fr',
        tablet: '1fr 1fr',
        desktop: 'repeat(4, 1fr)'
      }}
      gridTemplateRows={{
        mobile: '1fr',
        tablet: '330px 330px',
        desktop: 'auto'
      }}
    >
      {blackFridaySortCategories.map((item) => (
        <StyledWrapper position={position} sort={item.sort} key={item.sort}>
          <StyledLink href={item.link}>
            <StyledSummerButton title={item.name} />
          </StyledLink>
        </StyledWrapper>
      ))}
    </StyledGrid>
  )
}

export default SummerSubCategories

const StyledSummerButton = styled(BigAccentButton)`
  background-color: ${(props) => props.theme.colors.summerBackgroundButton};
  color: ${(props) => props.theme.colors.onBackground};
  margin-bottom: 30px;
  width: 275px;
  height: 50px;
  text-transform: none;
  p {
    letter-spacing: 1px;
  }
  /* &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.valentineBackgroundButton};
  } */
  ${validFor.mobile`
    width: 225px
  `}
  ${validFor.tablet`
    width: 225px
  `}
`

const StyledGrid = styled(Grid)`
  width: 100%;
`

const StyledWrapper = styled(Flex)`
  background-image: ${(props) =>
    (props.position === LandingPageSectionPosition.Center1 &&
      props.sort === 0 &&
      'url(https://i.factcool.com/summer/landing-page-summer_05.jpg)') ||
    (props.position === LandingPageSectionPosition.Center1 &&
      props.sort === 1 &&
      'url(https://i.factcool.com/summer/landing-page-summer_06.jpg)') ||
    (props.position === LandingPageSectionPosition.Center1 &&
      props.sort === 2 &&
      'url(https://i.factcool.com/summer/landing-page-summer_07.jpg)') ||
    (props.position === LandingPageSectionPosition.Center1 &&
      props.sort === 3 &&
      'url(https://i.factcool.com/summer/landing-page-summer_08.jpg)')};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  ${validFor.mobile`
    height: 300px;
    &:first-child {
      background-position: 0 -75px;    
    }
  `}
`

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`
